import React, { useRef, memo  } from 'react';
import styled from 'styled-components';
import { MB_TRUCK_NUMBER } from './truckCardComponents/truckNumberSection';
import { MB_DRIVER_NAMES } from './truckCardComponents/driverNamesSection';
import { MB_TRAILER } from './truckCardComponents/trailerSection'
import { MB_STATUS } from './truckCardComponents/statusSection';
import { MB_CURRENT_LOCATION } from './truckCardComponents/currentLocationSection';
import { MB_DESTINATION } from './truckCardComponents/finalDestinationSection'
import { MB_LOAD_NUMBER } from './truckCardComponents/loadNumberSection';
import { MB_GROSS, MB_PAYOUT_GROSS, MB_RPM, MB_PAYOUT_RPM } from './truckCardComponents/grossSections';
import { MB_NOTES } from './truckCardComponents/notesSection';
import { MB_FUEL_LEVEL } from './truckCardComponents/fuelLevelSection';
import { MB_TRUCK_STATE } from './truckCardComponents/currentState';
import { MB_TRUCK_STATUS } from './truckCardComponents/truckStatusSection';
import { useBoardStore } from '../../boardStore';

//4.2
export const truckLineHeight = 3.5; 
export const notesLineHeight = 3.3; 

const TruckCardContainer = styled.div`
    z-index:2;
    :hover{
        background-color: rgba(var(--light-gray-GRB), 0.1);
    }
    ${props => props.$plannerMode ? `min-height:${truckLineHeight}rem; max-height:${truckLineHeight}rem;`:''}
    &.invis{
        opacity:0;
    }
    &.beingDragged{
        background:var(--bg);
        position:fixed;
        box-shadow: #AAA 0px 8px 12px -4px;
        transition: transform 0.5s ease-in-out;
    }
    &>div:first-child{
    
        display:grid;
        grid-template-columns: ${props => props.$columnProportions ? props.$columnProportions : '1fr 1fr'};
        gap: 0.3rem;
        align-items:center;
        ${props => props.$plannerMode ? `
        box-sizing: border-box;
        padding: 0 0.5rem;
        min-width: ${props.$sectionWidthRem != null ? props.$sectionWidthRem : 50}rem;
        max-width: ${props.$sectionWidthRem != null ? props.$sectionWidthRem : 50}rem;
        min-height:${truckLineHeight}rem;
        max-height:${truckLineHeight}rem;
        .notesConteiner{
            max-height:${notesLineHeight}rem;
        }
        margin-left:0;
        ` : `
        padding: 0.6rem 0;
        .notesConteiner{
            max-height:${notesLineHeight}rem;
        }
        `}
        .standard_text{
            color:var(--gray);
            font-weight:600;
        }
    }
    
` 

export const TruckCard = memo(({mainBoardConf, truckData, truckId, trucksSetDataMethodsObject, popupViewManagingObject, plannerMode, currentCompanyId, mainlySolo}) => {

    const columnProps = mainBoardConf.columnProportions.trim();
    const currentTruckRef = useRef(null);
    // Backwards compat during rollout: support old prop shape `truckData` vs new `truckId`
    const resolvedTruckId = truckId != null
        ? String(truckId)
        : (typeof truckData === 'object' && truckData?.id != null ? String(truckData.id) : null);
    const currentTruck = useBoardStore(s => (resolvedTruckId ? s.trucksById[resolvedTruckId] : null));
    const initialLocationsLoaded = useBoardStore(s => s.initialLocationsLoaded);
    const truck = currentTruck || (typeof truckData === 'object' ? truckData : null);
    if(!resolvedTruckId || !truck) return null;

    return <TruckCardContainer 
        ref={currentTruckRef} 
        $plannerMode={plannerMode}
        $sectionWidthRem={mainBoardConf.sectionWidthRem}
        $columnProportions={columnProps.substr(columnProps.indexOf(' ')+1)} data-numval={truck.lastLoadsLastTimecode}  
        data-truckid={resolvedTruckId} 
        className={`TRUCK_CARD_CONTAINER`}
        data-trigger 
        data-target-id={resolvedTruckId}  >
        
        <div className="trckCrd">
            {mainBoardConf.columns.map((section, index)=>{
                if(section.spacing)return null;
                switch (section.name) {
                    case "truckNumber":
                        return <MB_TRUCK_NUMBER key={index} truckData={truck} trucksSetDataMethodsObject={trucksSetDataMethodsObject} mainlySolo={mainlySolo} />;
                    case "truckState":
                        return <MB_TRUCK_STATE key={index} status={truck.status} truckData={truck} timeRef={trucksSetDataMethodsObject["currentTimeRef"]} />;
                    case "drivers":
                        return <MB_DRIVER_NAMES key={index} trucksSetDataMethodsObject={trucksSetDataMethodsObject} driver1={truck.driver1} driver2={truck.driver2} popupViewManagingObject={popupViewManagingObject} hiddenField={section.hiddenField} />;
                    case "trailer":
                        return <MB_TRAILER key={index}  trailerData={truck.currentTrailer}  companyId={currentCompanyId} />
                    case "status":
                        return <MB_STATUS key={index} status={truck.status} tasks={truck.tasks} truckId={truck.id} popupViewManagingObject={popupViewManagingObject}  />
                    case "currentLocation":
                        return <MB_CURRENT_LOCATION key={index} currentLocation={truck.currentLocation} currentLatLng={truck.currentLatLng} initialLocationsLoaded={initialLocationsLoaded} />
                    case "destination":
                        return <MB_DESTINATION key={index} tasks={truck.tasks} />
                    case "currentLoadNumber":
                        return <MB_LOAD_NUMBER key={index} currentLoadId={truck.currentLoadId} />
                    case "fuelLevel":
                        return <MB_FUEL_LEVEL  key={index} currentFuelLevel={truck.currentFuelLevel} />
                    case "truckStatus":
                        return <MB_TRUCK_STATUS key={index} truck={truck} />;
                    case "notes":
                        return <MB_NOTES key={index}
                        allNotes={truck.allNotes}
                        truckId={resolvedTruckId}
                        popupViewManagingObject={popupViewManagingObject} />
                    case "gross":
                        return <MB_GROSS key={index} truckId={truck.id} />
                    case "rpm":
                        return <MB_RPM key={index} truckId={truck.id} />
                    case "payoutGross":
                        return <MB_PAYOUT_GROSS key={index} truckId={truck.id} />
                    case "payoutRpm":
                        return <MB_PAYOUT_RPM key={index} truckId={truck.id} />
                    default:
                        return null;
                }
            })}
        </div>        
    </TruckCardContainer>
})
